module.exports = __webpack_public_path__ + "static/screen_1-044fb54aee881aba3263b445c9bf0faf.png";